import { ClientInterface } from "."

interface elementInterface  {
    label: string,
    field: keyof ClientInterface,
    type: string,
    editable: boolean
}


export const elementsCEP: elementInterface[] = [
    {
        label: 'Bairro',
        field: 'neighborhood',
        type: 'text',
        editable: false
    },
    {
        label: 'Estado',
        field: 'state',
        type: 'text',
        editable: false
    },
    {
        label: 'Logradouro',
        field: 'street',
        type: 'text',
        editable: false
    },
    {
        label: 'Cidade',
        field: 'city',
        type: 'text',
        editable: false
    },
    {
        label: 'CEP',
        field: 'cep',
        type: 'text',
        editable: true
    },
    {
        label: 'Numero',
        field: 'number',
        type: 'text',
        editable: true
    },
    {
        label: 'Complemento',
        field: 'complement',
        type: 'text',
        editable: true
    },
    {
        label: 'Dias',
        field: 'days',
        type: 'text',
        editable: true
    },
    {
        label: 'Horário',
        field: 'hours',
        type: 'text',
        editable: true
    },
    {
        label: 'Cliente',
        field: 'name',
        type: 'text',
        editable: true
    },
]

// export const elementsClient: elementInterface[] = [

//     {
//         label: 'CEP',
//         field: 'cep',
//         type: 'text'
//     },
//     {
//         label: 'Numero',
//         field: 'number',
//         type: 'text'
//     },
//     {
//         label: 'Complemento',
//         field: 'complement',
//         type: 'text'
//     },
//     {
//         label: 'Dias',
//         field: 'days',
//         type: 'text'
//     },
//     {
//         label: 'Horário',
//         field: 'hours',
//         type: 'text'
//     },
// ]